import { useState, useEffect } from 'react';
import { PAGINATION_CONFIG, DEFAULT_PAGINATION, SEARCH_CONFIG, SORT_CONFIG } from '../utils/customerConstants';

export const useCustomerState = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const [customers, setCustomers] = useState([]);
  const [customerCount, setCustomerCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(PAGINATION_CONFIG.DEFAULT_PAGE);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION);
  const [hasNewRecords, setHasNewRecords] = useState(false);
  const [isOnFirstPage, setIsOnFirstPage] = useState(true);
  const [sortBy, setSortBy] = useState(SORT_CONFIG.DEFAULT_SORT_BY);

  // Debounce search term to avoid too many API calls
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, SEARCH_CONFIG.DEBOUNCE_DELAY);
    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  // Track if we're on the first page
  useEffect(() => {
    setIsOnFirstPage(currentPage === 1);
  }, [currentPage]);

  // Handle page changes
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    setIsOnFirstPage(newPage === 1);
  };

  // Reset to first page when searching
  const resetToFirstPage = () => {
    setCurrentPage(1);
    setIsOnFirstPage(true);
  };

  return {
    searchTerm,
    setSearchTerm,
    debouncedSearchTerm,
    customers,
    setCustomers,
    customerCount,
    setCustomerCount,
    currentPage,
    setCurrentPage,
    isLoading,
    setIsLoading,
    pagination,
    setPagination,
    hasNewRecords,
    setHasNewRecords,
    isOnFirstPage,
    handlePageChange,
    resetToFirstPage,
    sortBy,
    setSortBy
  };
};